<template>
  <AppImg :src="`/images/payment/${logo}.${extension}`" :alt="logo" />
</template>

<script setup lang="ts">
import type { PaymentLogo } from '~/types';

const EXTENSIONS: Record<PaymentLogo, 'svg' | 'png'> = {
  visa: 'svg',
  mastercard: 'svg',
  amex: 'svg',
  diners: 'svg',
  paypal: 'svg',
  mir: 'svg',
  bit: 'png',
  paybox: 'png',
};

const props = defineProps<{
  logo: PaymentLogo;
}>();

const extension = EXTENSIONS[props.logo];
</script>